import styled from "styled-components";

export const Navbar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: 0;
  left: 0;
  right: 0;

  ${({ transparent, theme }) => transparent ? `
    position: absolute;
    padding: ${theme.space[3]} ${theme.space[4]};
    background: none;
    border-bottom: none;
    z-index: ${theme.zIndex.dropdown - 1};
    pointer-events: none;

    & > * {
      pointer-events: auto;
    }
  ` : `
    position: sticky;
    padding: ${theme.space[3]} ${theme.space[4]};
    background: ${theme.colors.white};
    border-bottom: 1px solid ${theme.colors.gray200};
    z-index: ${theme.zIndex.sticky};
  `}
`;

export const NavGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
`;

export const NavTitle = styled.span`
  font-size: ${({ theme }) => theme.fonts.md};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;

export const BtnIcon = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: ${({ outlined, theme }) => outlined ? `1.5px solid ${theme.colors.primary}` : 'none'};
  background: ${({ theme, elevated }) => elevated ? theme.colors.white : 'transparent'};
  color: ${({ theme }) => theme.colors.primary};
  border-radius: ${({ theme }) => theme.radius.md};
  transition: ${({ theme }) => theme.transitions.fast};
  box-shadow: ${({ elevated, theme }) => elevated ? theme.shadows.md : 'none'};
  font-size: 24px;

  &:hover {
    background: ${({ outlined, elevated, theme }) =>
      outlined ? theme.colors.primary :
      elevated ? theme.colors.gray50 :
      theme.colors.primaryBg};
    color: ${({ outlined, theme }) => outlined ? theme.colors.white : theme.colors.primary};
    box-shadow: ${({ elevated, theme }) => elevated ? theme.shadows.lg : 'none'};
  }

  &:active {
    background: ${({ elevated, theme }) => elevated ? theme.colors.gray100 : theme.colors.gray200};
    box-shadow: ${({ elevated, theme }) => elevated ? theme.shadows.sm : 'none'};
  }
`;

export const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.colors.overlay};
  z-index: ${({ theme }) => theme.zIndex.overlay};
  opacity: ${({ open }) => open ? 1 : 0};
  visibility: ${({ open }) => open ? 'visible' : 'hidden'};
  transition: ${({ theme }) => theme.transitions.base};
`;

export const SidebarContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  max-width: 85vw;
  height: 100vh;
  background: ${({ theme }) => theme.colors.white};
  z-index: ${({ theme }) => theme.zIndex.modal};
  transform: translateX(${({ open }) => open ? '0' : '-100%'});
  transition: transform ${({ theme }) => theme.transitions.slow};
  display: flex;
  flex-direction: column;
  box-shadow: ${({ theme }) => theme.shadows.xl};
`;

export const SidebarHeader = styled.div`
  padding: ${({ theme }) => theme.space[7]} ${({ theme }) => theme.space[5]} ${({ theme }) => theme.space[5]};
  background: ${({ theme }) => theme.colors.primaryDark};
  color: ${({ theme }) => theme.colors.white};

  img {
    width: 160px;
    margin-bottom: ${({ theme }) => theme.space[2]};
  }
`;

export const SidebarSub = styled.div`
  font-size: ${({ theme }) => theme.fonts.xs};
  opacity: 0.6;
`;

export const SidebarNav = styled.div`
  flex: 1;
  padding: ${({ theme }) => theme.space[3]} 0;
  overflow-y: auto;
`;

export const SidebarLink = styled.a`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[3]};
  padding: ${({ theme }) => theme.space[3]} ${({ theme }) => theme.space[5]};
  color: ${({ active, theme }) => active ? theme.colors.primary : theme.colors.gray700};
  background: ${({ active, theme }) => active ? theme.colors.primaryBg : 'transparent'};
  font-size: ${({ theme }) => theme.fonts.base};
  font-weight: ${({ active }) => active ? 600 : 500};
  border-left: 3px solid ${({ active, theme }) => active ? theme.colors.successHover : 'transparent'};
  transition: ${({ theme }) => theme.transitions.fast};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => theme.colors.gray50};
    color: ${({ theme }) => theme.colors.primary};
  }

  svg {
    font-size: 22px;
    color: ${({ active, theme }) => active ? theme.colors.primary : theme.colors.gray400};
  }
`;

export const SidebarFooter = styled.div`
  padding: ${({ theme }) => theme.space[4]} ${({ theme }) => theme.space[5]};
  border-top: 1px solid ${({ theme }) => theme.colors.gray200};
  font-size: ${({ theme }) => theme.fonts.xs};
  color: ${({ theme }) => theme.colors.gray400};
`;
